import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import Icon from '@ant-design/icons';
import update from 'immutability-helper';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { DASHBOARD_TYPE, isAppModule } from '@utils/constants';
import { getFilterFromRules, getRulesFromFilter } from '@utils';
import { METRIC_SWITCH_MAP } from '@utils/metrics';
import { getFirstAppliedFilter, intervalSelector } from '@store/common/selectors';
import DrilldownIcon from '@icons/common/drilldown.svg';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { ALL_TRAFFIC } from '@utils/filter';

const LinkTrends = ({ rowData, metrics }) => {
  const dispatch = useDispatch();
  const interval = useSelector(intervalSelector);
  const { usecaseKey } = useSelector(activeDashboardSelector);
  const baseFilter = useSelector(getFirstAppliedFilter);

  const openDashboard = (e) => {
    e.stopPropagation();
    const { filter } = rowData;
    const metric = metrics[0];

    // combine with parent filter
    const subFilter = update(baseFilter.rule, {
      $push: [...filter.rule],
    });
    const allRules = getRulesFromFilter(subFilter, true);
    const filterToApply = getFilterFromRules(allRules, true);

    const dashboard = {
      // usecases key also enforces the new drilldown workflow (without injector layer)
      usecaseKey: 'compare-drilldown',
      metricsChartContainer: {
        metric: METRIC_SWITCH_MAP[metric] || metric,
        metrics,
      },
      common: {
        appliedFilters: [filterToApply],
        interval,
      },
      summary: {
        drilldownData: [ALL_TRAFFIC, filterToApply],
      },
      'module:trends': {
        base: {},
      },
    };

    if (isAppModule) {
      dispatch(
        createTempDashboard(
          DASHBOARD_TYPE.APP_EXPERIENCE_DRILLDOWN,
          dashboard,
          `${filterToApply.name}`,
        ),
      );
    } else {
      dispatch(
        createTempDashboard(DASHBOARD_TYPE.TRENDS_DRILLDOWN, dashboard, `${filterToApply.name}`),
      );
    }
  };

  if (isAppModule && usecaseKey) {
    return null;
  }

  return (
    <div>
      <Button icon={<Icon component={DrilldownIcon} />} type="text" onClick={openDashboard} />
    </div>
  );
};
export default LinkTrends;
